import React from 'react';
import { Link } from 'react-router-dom';
import './OperationalStatusPanel.css';

const formatDate = (value) => {
    if (!value) return 'ohne Termin';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const formatConfirmedAt = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const getPartyHeadline = (waitingOn = {}) => {
    if (waitingOn.type === 'none') return 'Abgeschlossen';
    return `Ball bei ${waitingOn.partyName || 'offen'}`;
};

const OperationalStatusPanel = ({ state, projectId, compact = false, onEdit = null, editPath = '' }) => {
    if (!state) return null;

    const waitingOn = state.waitingOn || {};
    const nextAction = state.nextInternalAction || {};
    const milestone = state.milestone || {};
    const tone = state.health?.tone || 'neutral';
    const confirmedAt = formatConfirmedAt(state.confirmedAt);

    return (
        <section className={`operational-status operational-status-${tone} ${compact ? 'operational-status-compact' : ''}`} aria-label="Operativer Projektstand">
            <div className="operational-status-head">
                <div>
                    <span className="operational-status-kicker">{state.template?.label || 'Förderfall'} · {milestone.macroPhase || 'Projektstand'}</span>
                    <h3>{milestone.label || 'Operativen Stand festlegen'}</h3>
                </div>
                <span className={`operational-status-health operational-status-health-${tone}`}>
                    {state.health?.label || 'Status offen'}
                </span>
            </div>

            <div className="operational-status-progress" aria-label={`Meilenstein ${Number(milestone.index || 0) + 1} von ${milestone.total || 1}`}>
                <span style={{ width: `${milestone.progress || 0}%` }} />
            </div>

            <div className="operational-status-grid">
                <div className="operational-status-current">
                    <span>{getPartyHeadline(waitingOn)}</span>
                    <strong>{waitingOn.label || 'Nächsten Schritt festlegen'}</strong>
                    <small>
                        {waitingOn.type === 'internal'
                            ? `${nextAction.responsible || 'Noch nicht zugewiesen'} · ${formatDate(nextAction.followUpAt)}`
                            : waitingOn.expectedAt
                                ? `Erwartet bis ${formatDate(waitingOn.expectedAt)}`
                                : 'Erwartungstermin offen'}
                    </small>
                </div>
                {waitingOn.type !== 'none' && (
                    <div className="operational-status-next">
                        <span>{waitingOn.type === 'internal' ? 'Verantwortlich' : 'Danach bei mawe-co'}</span>
                        <strong>{waitingOn.type === 'internal' ? nextAction.responsible || 'Nicht zugewiesen' : nextAction.title || 'Rücklauf prüfen'}</strong>
                        <small>
                            {waitingOn.type === 'internal'
                                ? nextAction.title || waitingOn.label
                                : `${nextAction.responsible || 'Nicht zugewiesen'} · Wiedervorlage ${formatDate(nextAction.followUpAt)}`}
                        </small>
                    </div>
                )}
            </div>

            <div className="operational-status-foot">
                <small>
                    {confirmedAt ? `Bestätigt ${confirmedAt}` : 'Automatisch abgeleitet'}
                    {state.source ? ` · ${state.source}` : ''}
                    {state.currentCommitment?.taskCount > 1 ? ` · ${state.currentCommitment.taskCount - 1} weitere offene Punkte` : ''}
                </small>
                <div className="operational-status-actions">
                    {onEdit && (
                        <button type="button" onClick={onEdit}>Stand aktualisieren</button>
                    )}
                    {editPath && !onEdit && (
                        <Link to={editPath}>Stand aktualisieren</Link>
                    )}
                    {projectId && !onEdit && (
                        <Link to={`/project/${projectId}/dashboard`}>Projekt öffnen</Link>
                    )}
                </div>
            </div>
        </section>
    );
};

export default OperationalStatusPanel;
